import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

const DashboardInsightDialog = ({ visible, onHide, insight, onNavigate }) => {
  if (!insight) return null;

  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      header={insight.title}
      className="dashboard-insight-dialog"
      style={{ width: "min(92vw, 620px)" }}
      breakpoints={{ "960px": "82vw", "640px": "94vw" }}
      footer={
        insight.navigate ? (
          <div className="flex justify-content-end">
            <Button
              label={insight.navigateLabel || "Ver reporte"}
              icon="pi pi-arrow-right"
              iconPos="right"
              onClick={() => onNavigate?.(insight.navigate)}
            />
          </div>
        ) : null
      }
    >
      <div className="dashboard-insight">
        <div className="dashboard-insight__value">{insight.value}</div>
        {insight.description && (
          <div className="dashboard-insight__description">{insight.description}</div>
        )}
        {Array.isArray(insight.details) && insight.details.length > 0 && (
          <div className="dashboard-insight__details">
            {insight.details.map((detail, index) => (
              <div className="dashboard-insight__detail" key={index}>
                <span>{detail.label}</span>
                <strong>{detail.value}</strong>
              </div>
            ))}
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default DashboardInsightDialog;
